<template lang="pug">
  .layout
    y-dialog(v-model="showModal" fill-height fluid scrollable persistent :fullscreen="$vuetify.breakpoint.xsOnly" transition="fade-transition" max-width="600px")
      v-card
        v-card-title.pa-0
          v-row.px-5.py-3(no-gutters align="center")
            v-col
              .mb-0.h6.basic800--text {{ $t('product_notes') }}
            v-col.shrink(v-if="notes.length > 0")
              v-btn.button-AA-tiny(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="clickAttachNote")
                v-icon(left small) mdi-plus
                | {{ $t('assign') }}
        v-divider.basic300

        v-card-text.pa-0          
          v-layout.my-6(v-if="isFetching")
            v-row.fill-height.ma-0(align='center' justify='center')
              v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
          .contain-layout(v-else)
            v-layout.my-6(v-if="notes.length == 0")
              v-row.fill-height.ma-0(align='center' justify='center')
                div.mx-auto.text-center
                  v-img.mx-auto.my-4(:src="require('@/assets/images/icon_empty_notes.png')" style="width:80px; height:80px" contain)
                  div.mt-2
                    .caption {{ $t('use_feature_collect_information') }}
                  v-btn.button-AA-tiny.my-6(v-if="createNote" color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="showAddProductDialog = true")
                    v-icon(left small) mdi-plus
                    | {{ $t('create_product_notes') }}
                  v-btn.button-AA-tiny.my-6(v-else color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" @click="clickAttachNote")
                    v-icon(left small) mdi-plus
                    | {{ $t('assign_product_notes') }}
                  div.p2.info500--text.text-decoration-underline(@click="openProductNotesImage") {{ $t('what_look_like') }}
            .items-layout(v-else)
              div.text-center.pb-2.mt-6
                div.c1.mb-2.primary400--text {{ $t('drag_and_drop') }}
                  ArrowsSortIcon.mx-1.mb-n1(size="16" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                  | {{ $t('icon_to_rearrage') }}
              draggable.my-2(tag="div" handle=".handle" :list="notes" @start="drag=true" @end="endMove" :move="checkMove")
                template(v-for='note in notes')
                  product-note-item(:parentNote="note" :company="company" :key="note.id" :product="product" @deleted="handleDeleteItem" :drag.sync="drag")
          
        v-card-actions.pa-4
          v-spacer
          v-btn(color='textColorAccent' depressed height=32 @click="showModal = false" dark)
            .button-AA-medium.basic100--text {{ $t('save') }}

    .modals
      attach-notes(v-if="showAttachNotesDialog" :open.sync="showAttachNotesDialog" :initialNotes="notes" @updateNotes="handleUpdateItem($event)" @addNewNote="showAddProductDialog = true")
      add-product-notes(v-if="showAddProductDialog" :open.sync="showAddProductDialog" :product="product" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState } from 'vuex'
import AttachNotes from '@/components/productnotes/dialogs/AttachNotes.vue'
import ProductNoteItem from '@/components/productnotes/ProductNoteItem.vue'
import AddProductNotes from '@/components/productnotes/dialogs/AddProductNotes.vue'
import draggable from 'vuedraggable'

let asyncForEach = async function(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array)
  }
}

export default {
  name: 'AssignProductNote',
  components: { AttachNotes, AddProductNotes, ProductNoteItem, draggable },
  props: ['open', 'company', 'product'],
  data: () => ({
    showHeader: true,
    lastScrollPosition: 0,
    isFetching: false,
    showAttachNotesDialog: false,
    showAddProductDialog: false,
    isTyping: false,
    notes: [],
    originalNotes: [],
    searchCountDown: null,
    drag: false,
    fromCategoryId: null,
    createNote: false
  }),
  computed: {
    ...mapState('user', ['member']),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  mounted () {
   this.fetchNotes()
  },
  methods: {
    fetchNotes() {
      this.isFetching = true
      let url = `/products/${this.product.id}/notes/?page_size=-1&company=${this.company.id}`
      this.$axios.get(url).then((response) => {
        if (response.data && response.data.results.length > 0) {
          this.notes = response.data.results
          this.originalNotes = JSON.parse(JSON.stringify(this.notes))
        } else {
          this.checkProductNotes()
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isFetching = false
      })
    },
    checkProductNotes () {
      this.$axios.get(`/product_notes/?company=${this.company.id}`)
        .then(resp => {
          if (resp.data.count === 0) {
            this.createNote = true
          }
        })
    },
    clickAttachNote () {
      this.showAttachNotesDialog = true
    },
    handleDeleteItem (item) {
      this.notes = this.notes.filter((x) => x !== item)
    },
    handleAddItem (item) {
      this.notes.splice(0, 0, item)
    },
    async handleUpdateItem (notes) {
      this.isFetching = true
      await asyncForEach(notes, async (note) => {
        if (this.originalNotes.map(p => (p.id)).includes(note.id)) {
          this.originalNotes = this.originalNotes.filter((x) => x.id !== note.id)
        } else {
          await this.axios.post(`/product_notes/${note.id}/products`, {
            single_id: this.product.id
          })
        }
      })
      await asyncForEach(this.originalNotes, async (deleted) => {
        await this.axios.delete(`/product/${this.product.id}/notes/${deleted.id}/`)
      })
      this.notes = notes
      this.isFetching = false
    },
    checkMove (e) {
      let fromCategory = this.notes[e.draggedContext.index]
      // console.log(e)
      this.params = {
        position: e.draggedContext.futureIndex,
      }
      this.fromCategoryId = fromCategory.id
    },
    endMove () {
      this.drag = false
      if (!this.fromCategoryId) {
        return
      }
      this.$axios.post(`/products/${this.product.id}/notes/${this.fromCategoryId}/move/`, this.params).catch(() => {})
    },
    openProductNotesImage () {
      window.open(`../preview_product_notes.jpg`, '_blank')
    }
  }
}
</script>
<style scoped>
.sticky-header-container {
  position: relative;
  background-color: var(--v-basic100);
  height: 80px;
}
.sticky-header{
  position: fixed;
  transition: 0.3s all ease-out;
  transform: translate3d(0, 0, 0) !important;
  z-index: 3;
  width: 100%;
  max-width: 600px;
  background-color: var(--v-basic100);
}
.sticky-header.hidden-header{
  transform: translate3d(0, -100%, 0) !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "use_feature_collect_information": "Use this feature to collect more information from customers about a product",
    "assign_product_notes": "Assign product notes",
    "drag_and_drop": "Drag and drop the",
    "icon_to_rearrage": "icon to rearrange the notes"
  },
  "id": {
    "use_feature_collect_information": "Gunakan fitur ini untuk mengumpulkan lebih banyak informasi dari pelanggan tentang suatu produk",
    "assign_product_notes": "Tetapkan Nota Produk",
    "drag_and_drop": "Klik dan seret",
    "icon_to_rearrage": "ikon untuk mengatur ulang produk"
  }
}
</i18n>